import React, {FC} from 'react';
import styled from 'styled-components';

import {greys} from '../../../../libs/shared/ui/src/styles/colorStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import frontLogo from '../../assets/images/frontLogo.png';

/*
 * Styles.
 */

const FrontPowerWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const StyledImage = styled.img`
  height: 20px;
  width: 14px;
  margin-right: 16px;
`;

const FrontMessage = styled.div`
  font-size: ${fontSizes.medium};
  line-height: 21px;
  font-weight: ${fontWeights.normal};
  color: ${greys.shade60};
`;

/*
 * Component.
 */

export const FrontPower: FC = () => (
  <FrontPowerWrapper>
    <StyledImage src={frontLogo} />
    <FrontMessage>Powered by Front</FrontMessage>
  </FrontPowerWrapper>
);
